import React, { useState } from 'react'
import { Button, Modal } from 'antd'
import { useSelector } from 'react-redux';
import ComposeMailModal from './ComposeMailModal';

const SendMail = (props: any) => {
  const { open, handelClose } = props;
  const employeeDetails = useSelector((state: any) => state?.employee?.employeeDetails);
  const [emailModal, setEmailModal] = useState(false);

  const onCancel = () => {
    setEmailModal(false);
    handelClose()
  }
  const handelSendMail = () => {
    setEmailModal(true);
  }
  const handelCancel = () => {
    setEmailModal(false);
    handelClose()
  }

  return (
    <Modal className='deporvision' centered open={open} footer={null} maskClosable={false}>

      <p className='text-center text-[#636363] text-[20px] pt-3'>Do you really want to proceed with your resignation?</p>
      <div className="flex justify-center mt-8 pb-3">
        <Button type="primary" shape="round" className='addButton w-[140px]   _deprovision mr-4' onClick={() => onCancel()} >
          No
        </Button>
        <Button type="primary" shape="round" className='addButton w-[140px] deprovision text-[#d23b7d]' onClick={() => handelSendMail()} >
          Yes
        </Button>
      </div>

      {
        emailModal && <ComposeMailModal sendMail={emailModal} handelCancel={handelCancel} title='Resignation' actionType="create" data={""} />
      }
    </Modal>
  )
}

export default SendMail
